"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefOption = undefined;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DefOption = exports.DefOption = function DefOption(_ref) {
  var checked = _ref.checked,
      option = _ref.option,
      isSingle = _ref.isSingle;
  return _react2.default.createElement(
    "div",
    { className: "Option__renderer" },
    _react2.default.createElement(
      "span",
      { className: "Option__label" },
      option.label
    ),
    !isSingle && _react2.default.createElement("input", {
      type: "checkbox",
      defaultChecked: checked,
      tabIndex: "-1"
    })
  );
};